
<template>
  <AppSearch/>
</template>

<script>
import AppSearch from "@/components/Search/AppSearch.vue";

export default {
  components: {
    AppSearch,
  },
}
</script>
